// @flow
import React from 'react';
import { startCase } from 'lodash';

import { DataGrid } from '../grid-utils/DataGrid';
import { ChildRenderer, CurrencyZeroDPRenderer, MarginRenderer } from '../grid-utils/renderers';
import { HEADER_SUFFIX_FOR_DOLLAR_COLUMNS } from '../../../constants';
import { DEFAULT_COLUMN_DEFINITION_FOR_SIMPLIFIED_GRID } from '../grid-utils/constants';
import { doesStringContainSubstringCaseAgnostic } from '../../../common-utils/utils';

const ValueRenderer = (props) => {
  const shouldUseMarginRenderer = doesStringContainSubstringCaseAgnostic(
    props.data.Field,
    'margin'
  );

  return shouldUseMarginRenderer ? MarginRenderer(props) : CurrencyZeroDPRenderer(props);
};

const columnDefs = [
  {
    field: 'Field',
    backEndFieldName: 'field',
    minWidth: 500,
    cellRenderer: ChildRenderer,
    dependentFields: ['is_child'],
  },
  {
    field: 'Value',
    backEndFieldName: 'value',
    minWidth: 150,
    cellRenderer: ValueRenderer,
    headerSuffix: HEADER_SUFFIX_FOR_DOLLAR_COLUMNS,
  },
];

export const CommitSummaryTable = ({ inputDataSource, label, width = '730px', height = null }) => {
  const inputDataSourceInFrontEndFormat = {};

  for (const [key, value] of Object.entries(inputDataSource)) {
    inputDataSourceInFrontEndFormat[startCase(key.split('_').join(' '))] = value;
  }

  return (
    <DataGrid
      bannerFieldNameInColDefsForFullWidthRows="Field"
      columnDefs={columnDefs}
      defaultColDef={DEFAULT_COLUMN_DEFINITION_FOR_SIMPLIFIED_GRID}
      height={height}
      inputDataSource={inputDataSourceInFrontEndFormat}
      label={label}
      noHeader={true}
      width={width}
    />
  );
};
